import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'
import { orderPartial } from './partials'

const fetchOrdersQuery = `
  query ShopifyFetchOrders(
    $customerId: ID!,
    $limit: Int!
  ) {
    customer(id: $customerId) {
      id
      orders(first: $limit, reverse: true) {
        edges {
          node {
            ${orderPartial}
          }
        }
      }
    }
  }
`

const doFetchOrders = (integrationId, customerGid, limit) => dispatch => {
  const variables = { customerId: customerGid, limit }
  return dispatch(
    doGraphqlRequest(types.FETCH_ORDERS_REQUEST, fetchOrdersQuery, variables, {
      graphqlFunc: graphql(integrationId),
    })
  )
}

export default doFetchOrders
